import { TimePeriod } from "../enums/timePeriod.enum";

export class afDateUtils {
  static generateStartRange(timePeriod: TimePeriod | undefined): Date {
    const currentDate = new Date();
    let startDate: Date;
    switch (timePeriod) {
      case TimePeriod.LastWeek:
        startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - 7);

        break;

      case TimePeriod.LastMonth:
        startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 30);

        break;

      case TimePeriod.Last3Months:
        startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 90);

        break;

      case TimePeriod.Last6Months:
        startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 180);

        break;

      case TimePeriod.LastYear:
        startDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());

        break;

      default:
        throw new Error('Invalid time period');
    }

    return startDate;
  }


}
